import "./DecaturRemodelingCostGuide.module.css";
import Header from "@/reusable_sections/Header";
import CostGuideHero from "./sections/CostGuideHero";
import RemodelingCostDrivers from "./sections/RemodelingCostDrivers";
import CostFactorsFaq from "./sections/CostFactorsFaq";
import EstimateForm from "./sections/EstimateForm";
import Footer from "@/reusable_sections/Footer";
export default function DecaturRemodelingCostGuidePage() {
  return <div>
      <Header />
      <CostGuideHero />
      <RemodelingCostDrivers />
      <CostFactorsFaq />
      <EstimateForm />
      <Footer />
    </div>;
}